export default __webpack_public_path__ + "static/media/cloud.159f1fa4.png";